import { render, staticRenderFns } from "./TabsLanguageSwitcherButton.vue?vue&type=template&id=56149a54&"
import script from "./TabsLanguageSwitcherButton.vue?vue&type=script&lang=ts&"
export * from "./TabsLanguageSwitcherButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports